const CAPTURE_QUERY_KEYS = ["capture", "figma-qa", "screenshot"];
const TRUTHY_CAPTURE_VALUES = new Set(["1", "true", "yes", "on"]);

const isTruthyCaptureValue = (value) =>
  value != null &&
  TRUTHY_CAPTURE_VALUES.has(String(value).trim().toLowerCase());

export const isCaptureModeEnabled = (search = "") => {
  const params = new URLSearchParams(search || "");

  return CAPTURE_QUERY_KEYS.some((key) =>
    isTruthyCaptureValue(params.get(key))
  );
};

export const syncCaptureModeAttribute = (enabled) => {
  if (typeof document === "undefined") return;

  if (enabled) {
    document.documentElement.setAttribute("data-capture-mode", "true");
    return;
  }

  document.documentElement.removeAttribute("data-capture-mode");
};
